export function sanitize(text: string) {
  return text
    .trim()
    .split("\n")
    .map((s) => s.trim())
    .join("\n")
    .replace(/\n\n+/g, "\n\n");
}
